export enum ToastConstants {
  SHOW_TOAST = 'SHOW_TOAST',
  HIDE_TOAST = 'HIDE_TOAST',
  RESET_TOAST = 'RESET_TOAST',
}

export enum ToastColor {
  Success = 'success',
  Error = 'danger',
  Warning = 'warning',
  Info = 'info',
}
